import { combineReducers } from 'redux'
import * as actionTypes from './actionTypes'

export const validReducer = (state = true, action) => {
	switch (action.type) {
		case actionTypes.VALIDATE_BOOK_INPUTS_SUCCESS:
			return action.valid
		default:
			return state
	}
}

export const fieldsInErrorReducer = (state = {}, action) => {
	switch (action.type) {
		case actionTypes.VALIDATE_BOOK_INPUTS_SUCCESS:
			return action.valid
				? {}
				: action.errors.reduce((errors, error) => {
						if (!errors[error.fieldName]) errors[error.fieldName] = []
						errors[error.fieldName].push(error.error)
						return errors
				  }, {})

		default:
			return state
	}
}

export default combineReducers({
	valid: validReducer,
	fieldsInError: fieldsInErrorReducer,
})

export const isValid = state => state.valid
export const getFieldsInError = state => state.fieldsInError
